export default [
  {
    path: "noviceTasks",
    name: "noviceTasks",
    meta: {
      title: "新手任务"
    },
    component: () =>
      import("@/views/Home/NoviceTasks/NoviceTasks/index.vue")
  },
];
